import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import Url from 'url-parse';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import Link from '../../Link';

import s from './presetsTabsScss/Primary.scss';

@withStyles(s)
export default class LinkedTabs extends React.PureComponent {
  static propTypes = {
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        tabClassName: PropTypes.string,
        linkTo: PropTypes.string.isRequired,
        value: PropTypes.string,
      }),
    ).isRequired,
    className: PropTypes.string,
    tabIndicatorProps: PropTypes.shape({}),
    currentTabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    classes: PropTypes.shape({
      root: PropTypes.string.isRequired,
      scrollButtons: PropTypes.string.isRequired,
      tabsIndicator: PropTypes.string.isRequired,
      tabRoot: PropTypes.string.isRequired,
      tabLabel: PropTypes.string.isRequired,
    }),
  };

  static contextTypes = {
    locale: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    organizationSlug: PropTypes.string.isRequired,
  };

  static defaultProps = {
    className: '',
    tabIndicatorProps: {},
    currentTabIndex: -1,
    classes: {
      root: s.root,
      scrollButtons: s.scrollButtons,
      tabsIndicator: s.tabsIndicator,
      tabRoot: s.tabRoot,
      tabLabel: s.tabLabel,
    },
  };

  render() {
    const { classes, tabs, className, tabIndicatorProps, ...rest } = this.props;
    const { path, organizationSlug, locale } = this.context;

    let currentTabIndex = _.findIndex(
      tabs,
      t =>
        new Url(
          `/${locale}${organizationSlug ? `/${organizationSlug}` : ''}${
            t.linkTo
          }`,
        ).pathname === path,
    );

    if (this.props.currentTabIndex !== -1) {
      currentTabIndex = this.props.currentTabIndex;
    }

    return (
      <nav>
        <Tabs
          variant="scrollable"
          scrollButtons="on"
          textColor="primary"
          value={currentTabIndex === -1 ? 0 : currentTabIndex}
          TabIndicatorProps={{
            className: classes.tabsIndicator,
            ...tabIndicatorProps,
          }}
          className={cx(classes.root, className)}
          classes={{
            root: classes.root,
            scrollButtons: classes.scrollButtons,
          }}
          onChange={this.onChange}
          {...rest}
        >
          {_.map(tabs, (tab, i) => {
            if (!tab) {
              return null;
            }
            const { label, tabClassName, linkTo, value, ...other } = tab;
            return (
              <Tab
                label={
                  currentTabIndex === i ? (
                    <Typography component="h1" className={s.activeTab}>
                      {label}
                    </Typography>
                  ) : (
                    label
                  )
                }
                key={linkTo + i}
                classes={{
                  root: classes.tabRoot,
                  textColorPrimary: classes.tabLabel,
                }}
                className={tabClassName}
                component={Link}
                value={value || i}
                to={linkTo}
                {...other}
              />
            );
          })}
        </Tabs>
      </nav>
    );
  }
}
